@if ((control?.touched || control?.dirty) && control?.invalid) {
  <ul>
    @for (error of errorList$ | async; track error) {
      <li>
        <ion-text color="danger">{{ error.message }}</ion-text>
      </li>
    }
  </ul>
}
